// Preferences
import React, { useEffect, useState, useRef } from "react";
import { Footer } from '../../components/footer/Footer';
import './PreferencesPage.scss';
const preferencesPic = '/org/gds/gear.png';


function PreferencesSettingsPage() {
  const [errorMessage, setErrorMessage] = useState("");


  const [selectedMode, setSelectedMode] = useState("skill");

  const [productSKU] = useState("Agent Ann");
  const [productSelection] = useState("");
  const [productTitle] = useState("");
  const [productImage] = useState("");
  const [procuctFeatures] = useState("");
  const [productDescription] = useState("");
  const [productPrice] = useState("");
  const [productCategory] = useState("Enterprise");
  const [productSkills] = useState("");

  const [selectedCard, setSelectedCard] = useState<string | null>(null); // Track selected card

   /* Infinite Scolling */
  const containerRef = useRef<HTMLDivElement>(null); // Continuous infinite scroll state - with type

  const [items, setItems] = useState(Array.from({ length: 10 }, (_, i) => `Signup Item ${i + 1}`)); // infinite scrolling items
  const loadMoreItems = () => { 
    setItems(prevItems => [
      ...prevItems,
      ...Array.from({ length: 10 }, (_, i) => `Signup Item ${prevItems.length + i + 1}`)
    ]);
  }; 
  // Hook for loading and scolling items
  useEffect(() => { 

    const handleScroll = () => {
    if (!containerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 10) {
      loadMoreItems();
    }
    };

    const container = containerRef.current;
    if (container) {
      console.log("✅ Scroll to top on load");
      container.addEventListener("scroll", handleScroll, { passive: true })
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []); // <-- end of added hook
  /* Infinite Scolling */

  /* Preferences Data */
  const preferencesSettings = [
    {
        id: "high-performance-teams",
        productTitle: "High-Performance Teams Training with Coach Yourself To Win",
        productSKU: "Agent Ann",
        productCategory: "Self-Coaching",
        productDescription: "Enhance leadership and team collaboration with this training module.",
        productAgentName: "",
        productAgentId: "",
        productSelection: "",
        productImage: "🎯",
        productFeatures: "Team building, Leadership coaching, Strategic execution",
        productPrice: "$ TBD",
        productSkills: "Leadership, Team Management, Execution",
    },
    {
        id: "conflict-management",
        productTitle: "Conflict Management Training",
        productSKU: "Agent Ann",
        productCategory: "Team Enterprise",
        productDescription: "Learn techniques to handle workplace conflicts efficiently.",
        productAgentName: "",
        productAgentId: "",
        productSelection: "",
        productImage: "🤝",
        productFeatures: "Negotiation, Mediation, Effective communication",
        productPrice: "$ TBD",
        productSkills: "Conflict Resolution, Mediation, Workplace Communication",
    },
    {
        id: "active-listening",
        productTitle: "Active Listening Skills",
        productSKU: "Agent Ann",
        productCategory: "Team Enterprise",
        productDescription: "Improve your listening and communication skills with this training.",
        productAgentName: "",
        productAgentId: "",
        productSelection: "",
        productImage: "👂",
        productFeatures: "Empathy, Communication, Rapport building",
        productPrice: "$ TBD",
        productSkills: "Active Listening, Empathy, Relationship Building",
    },
    {
        id: "organizational-development",
        productTitle: "Organizational Development Coaching",
        productSKU: "Agent Ann",
        productCategory: "Enterprise",
        productDescription: "Boost organizational efficiency with structured development training.",
        productAgentName: "",
        productAgentId: "",
        productSelection: "",
        productImage: "🗂️",
        productFeatures: "Change Management, Performance Improvement, Employee Engagement",
        productPrice: "$ TBD",
        productSkills: "Organizational Change, Leadership, Strategy",
    },
    ];

    const handleSelectCard = (id: string) => {
      console.log(" ✅  Set Card: ", {id});
      setSelectedCard(id); // Update the selected card ID
    };

    const getSelectedCard = () => selectedCard;
    const handleNextButton = () => {
        console.log(" ✅ Checking Selected Card"); 

        if (!getSelectedCard()) {
            alert("Please select a Learning Track before submitting.");
            return;
        }
        console.log("Selected Track: ", getSelectedCard());
        // FIXES 3.2: no longer continues to /setup/orientation (deprecated; the page is kept, the connection removed)
    };


   return (

    <div id="pageContainer" className="pageContainer"  ref={containerRef}>
        <style>{`
          /*
            PreferencesPage.scss styles .preferencesPageContainer / .preferences-container,
            but the markup below actually uses .pageContainer / .preferencesContainer - so
            none of that page-background/centering CSS was ever applied here, and
            .signUpButton/.signInButton/.signUpColor (styled only in SignInUpPage.scss,
            which this page never loads) rendered as plain unstyled buttons. This block
            targets the classes actually used in this file's JSX and matches SignUpPage's
            palette/layout, with !important so it isn't silently dropped like before.
            The logo also used margin-top:5vh/6vh/8vh (viewport-height relative, different
            per breakpoint) which is why it drifted on resize - replaced with a fixed,
            top-of-card position.
          */
          body, html, #root {
            background-color: #551540 !important;
          }
          #pageContainer, .pageContainer {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            width: 100% !important;
            min-height: 100vh !important;
            height: auto !important;
            background-color: #551540 !important;
            color: #F3F1E8 !important;
            padding: 24px 16px 64px !important;
            box-sizing: border-box !important;
            overflow-x: hidden !important;
          }
          #pageContainer * {
            box-sizing: border-box;
          }
          #preferencesContainer, .preferencesContainer {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            width: 100% !important;
            max-width: 720px !important;
            margin: 0 auto !important;
            text-align: center !important;
          }
          .pageImageContainer, #pageImageContainer {
            width: 100% !important;
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
            margin: 0 auto 12px !important;
          }
          .preferencesPic, #preferencesPic {
            width: 90px !important;
            max-width: 90px !important;
            height: auto !important;
            margin: 0 auto !important;
            display: block !important;
          }
          .preferencesTitle {
            text-align: center !important;
            width: 100% !important;
            margin: 0 auto 10px !important;
            color: #F3F1E8 !important;
            font-size: 1.4rem !important;
            font-weight: 600 !important;
          }
          .preferencesForm {
            width: 100% !important;
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
          }
          .mode-toggle-container {
            width: 100% !important;
            max-width: 720px !important;
            margin: 4px auto 12px !important;
            border-radius: 10px !important;
          }
          .preferencesSettings-list {
            width: 100% !important;
            max-width: 720px !important;
            margin: 16px auto !important;
          }
          .preferences-card {
            width: 100% !important;
          }
          .preferencesButtonContainer {
            display: flex !important;
            flex-wrap: wrap !important;
            justify-content: center !important;
            gap: 12px !important;
            width: 100% !important;
            max-width: 300px !important;
            margin: 16px auto 0 !important;
          }
          .signUpButton, .signInButton {
            flex: 1 1 130px !important;
            max-width: 190px !important;
            padding: 10px 18px !important;
            border: none !important;
            border-radius: 24px !important;
            font-weight: 600 !important;
            cursor: pointer !important;
          }
          .signUpColor {
            background-color: #551540 !important;
            color: #F3F1E8 !important;
          }
          @media (max-width: 480px) {
            .preferencesPic, #preferencesPic {
              width: 70px !important;
              max-width: 70px !important;
            }
            .preferencesButtonContainer {
              flex-direction: column !important;
              align-items: stretch !important;
              max-width: 100% !important;
            }
          }
        `}</style>
        <div id="preferencesContainer" className="preferencesContainer">
          {/* Error Message Display */}
          {errorMessage && <div className="errorStatus">{errorMessage}</div>}

          {/* Logo: fixed at top, centered - no longer vh-based so it can't drift on resize */}
          <div id="pageImageContainer" className="pageImageContainer">
              <img
              id="preferencesPic"
              className="preferencesPic"
              src={preferencesPic}
              alt="Company Logo"
              />
          </div>

          <div className="preferencesTitle">Preferences & Settings</div>

          {/* Preferences Form */}
          <div className="preferencesForm">
        <div className="mode-toggle-container">
        <h2 className="preferencesSubTitle">Select a training module to enhance your skills.</h2>
          <label className="mode-option">
            <input
            type="radio"
            name="mode"
            value="skill"
            checked={selectedMode === "skill"}
            onChange={() => setSelectedMode("skill")}
            />
            <span className="radio-label">Cirriculum Mode</span>
        </label>

        <div className="mode-options-container">
            <label className="mode-option">
                <input
                type="radio"
                name="mode"
                value="reference"
                checked={selectedMode === "reference"}
                onChange={() => setSelectedMode("reference")}
                />
                <span className="radio-label">Coach Mode</span>
            </label>
            </div>
        </div>
       
           <div className="preferencesSettings-list">
            {preferencesSettings.map((item) => (
            <div key={item.id} className="preferences-card" style={{ border: selectedCard === item.id ? "5px solid #007bff" : "1px solid #ccc" }}>

                <div className="preferences-info">

                <div className="preferences-header">
                    <div className='preferences-image' dangerouslySetInnerHTML={{ __html: item.productImage }}></div>
                    <div className="spacerDiv"></div>
                    <b className="preferences-title">{item.productTitle}</b>
                </div>

                <strong className="preferences-category">{item.productCategory}</strong>:&nbsp;
                <span className="preferences-description">{item.productDescription}</span>
               
                <div className="preferences-features">
                    <strong>Features:&nbsp;</strong> {item.productFeatures}
                </div>

                <div className="preferences-skills">
                    <strong>Skills Gained:&nbsp;</strong> {item.productSkills}
                </div>

                <div className="preferences-actions">
                <table style={{width:"100%"}}><tr><td>
                    <span className="preferences-price">{item.productPrice}</span>
                </td><td className="align-right">
                    <button 
                    className="signUpButton signUpColor"
                    onClick={() => handleSelectCard(item.id)}
                    >Select
                    </button>
                </td></tr></table>
                </div>

                </div>
            </div>
            ))}
        </div>

          </div>
        
          <br />
          {/* Buttons */}
          <div className="preferencesButtonContainer align-center">
            <button className="signUpButton signUpColor" type="button" 
              onClick={() => (window.location.href = "/signin")}>
              Sign In
            </button>
            <button 
             className="signInButton signUpColor"
             onClick={() => handleNextButton()}
             >Next</button>
          </div>
        
        </div>
    <Footer/>
  </div>

  );
}

export default PreferencesSettingsPage;
